/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.08.2016.
 */

import {SuccessState} from '../../utils';

import {
  ADD_TO_FAVORITES, REMOVE_FROM_FAVORITES, GET_FAVORITES
} from '../../actions/favorites/actions-favorites';

import {
  EMIT_COLLECTION_FAVORITES_UPDATE
} from '../../actions/emit/actions-emit';

const INIT_STATE = {
  favorites: {
    inProgress: false,
    collection: []
  }
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {
    case EMIT_COLLECTION_FAVORITES_UPDATE: {

      return {
        favorites: {
          ...state.favorites,
          collection: [...action.payload]
        }
      };
    }

    case SuccessState(GET_FAVORITES):

      return {
        ...state,
        favorites: {
          ...state.favorites,
          collection: [...action.payload]
        }
      };

    //case ADD_TO_FAVORITES: {
    //
    //  return {
    //    favorites: {
    //      ...state.favorites,
    //      collection: [...lh.a]
    //    }
    //  };
    //}
    //
    //case REMOVE_FROM_FAVORITES: {
    //
    //  return {
    //    favorites: {
    //      ...state.favorites,
    //      collection: [...action.payload]
    //    }
    //  };
    //}

    default:

      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/favorites/reducer-favorites.js